import { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import CookieKeys from '../../constants/CookieKeys';
import LocalStorageKeys from '../../constants/LocalStorageKeys';
import IdentityContext from '../../contexts/IdentityContext';
import Cookies from '../../utils/Cookies';
import useAnalytics from '../../hooks/useAnalytics';
import { ANALYTICS_EVENT_TYPES } from '../../constants/analyticsEvents';

const AuthCallback = (): JSX.Element | null => {
  const { REACT_APP_P_STUDIO_GROUP } = process.env;

  const { onAccessTokenReceived, identity } = useContext(IdentityContext);

  const location = useLocation();

  const { capture } = useAnalytics();
  const [loginCaptured, setLoginCaptured] = useState(false);

  const searchParams = new URLSearchParams(location.search);

  const accessToken = searchParams.get('access_token');
  const refreshToken = searchParams.get('refresh_token');
  const returnUrl = searchParams.get('returnUrl');

  useEffect(() => {
    if (!accessToken) throw new Error('no access token');
    if (!refreshToken) throw new Error('no refresh token');

    localStorage.setItem(LocalStorageKeys.p_access_token, JSON.stringify(accessToken));
    localStorage.setItem(LocalStorageKeys.p_refresh_token, JSON.stringify(refreshToken));

    Cookies.set(CookieKeys.p_authenticated, Date.now().toString());

    onAccessTokenReceived(accessToken);
  }, [onAccessTokenReceived, accessToken, refreshToken]);

  useEffect(() => {
    const navigateDashboard = async () => {
      if (!identity.isAuthenticated) return;

      await capture({
        eventType: ANALYTICS_EVENT_TYPES.LOGIN,
        objectId: REACT_APP_P_STUDIO_GROUP,
      });
      setLoginCaptured(true);
    };

    navigateDashboard();
  }, [identity, capture, REACT_APP_P_STUDIO_GROUP]);

  // Using <Navigate /> instead of useNavigate due to instability of useNavigate hook.
  // if we navigate in the effect above, the hook will be triggered multiple times after auth.
  if (loginCaptured) return <Navigate to={returnUrl || '/'} />;

  return null;
};

export default AuthCallback;
